import React from "react";

/**
 * A toggle button for switching between percentage and points modes
 */
export function ModeToggle({ isPercentageMode, onChange, className = "" }) {
  return (
    <div className={`join ${className}`}>
      <button
        onClick={() => onChange(false)}
        className={`join-item btn btn-sm ${
          !isPercentageMode ? "btn-primary" : "btn-ghost"
        }`}
      >
        Points
      </button>
      <button
        onClick={() => onChange(true)}
        className={`join-item btn btn-sm ${
          isPercentageMode ? "btn-primary" : "btn-ghost"
        }`}
      >
        Percentage
      </button>
    </div>
  );
} 